export class MessageService {
    static  RegistrationSuccess ='Registration successfully.';
    static  AccountActive ='Account Activate successfully.';
    static  AccountChange ='Password changed successfully.';
   
}
export default MessageService